import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Selectors
import { makeSelectTimesheetEntryValue } from '../../../../../../../../../../services/timesheetEntries/selectors';

interface Props {
    entityName?: ?string;
}

export class TimesheetEntryEntityName extends React.PureComponent<Props> {
    render() {
        const { entityName } = this.props;
        if (!entityName) return null;
        return entityName;
    }
}

const mapStateToProps = createStructuredSelector({
    entityName: makeSelectTimesheetEntryValue('entityName')
});

export default connect(mapStateToProps)(TimesheetEntryEntityName);
